// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Wfe+p","flex_fist_div":"Header_flex_fist_div__rcbfe"};